import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import {
  candidateMatchBandBadgeVariant,
  candidateMatchBandLabel,
  type CandidateMatchBand,
} from '@/lib/candidate-match-bands'
import { normalizeMatchBand, type MatchBandInput } from '@/lib/match-bands'

export type MatchBandBadgeProps = {
  band: MatchBandInput | CandidateMatchBand
  /** Shown when band is null but the role was analysed (sub-threshold / legacy). */
  caption?: string | null
  className?: string
}

/** Shared band chip for candidate saved jobs, applications, and employer/recruiter match quality. */
export function MatchBandBadge({ band, caption, className }: MatchBandBadgeProps) {
  const normalized = normalizeMatchBand(band)
  const label = normalized
    ? candidateMatchBandLabel(normalized)
    : caption?.trim() || null
  if (!label) return null

  const variant = normalized ? candidateMatchBandBadgeVariant(normalized) : 'outline'
  return (
    <Badge
      variant={variant}
      className={cn(
        'text-xs',
        !normalized && 'border-border bg-muted/50 text-muted-foreground font-medium',
        className,
      )}
    >
      {label}
    </Badge>
  )
}
